module.exports = __webpack_public_path__ + "img/MobileSelectedFeedbackPoor.f3f2a521.png";